<template >
    <div class="acomodar">
          <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-2">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-lines-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            SEGUIMIENTO DE CESESa
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE TRABAJADORES
          </p>
        </div>
      </div>
    </div>

    <SegCeseFilters
      :dni.sync="Dni"
      :apellidos.sync="Apellidos"
      :subSubCentro.sync="SubSubCentro"
    />

    <SegCeseTable
      :items="paginatedGestionCese"
      :total-items="filteredGestionCese.length"
      :current-page.sync="currentPage"
      :total-pages="totalPages"
      :from-id-cese="from.idCese"
      @update:item-accion-cese="actualizarEstado"
      @register-item="Registro"
      @navigate-to-descuento="navigateToDescuento"
    />
  </div>
    </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import SegCeseFilters from '@/components/ModContratos/SegCese/SegCeseFilters.vue';
import SegCeseTable from '@/components/ModContratos/SegCese/SegCeseTable.vue';
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
  name: 'FrontendTopasSeguimientoCese',
  components: {
    SegCeseFilters,
    SegCeseTable
  },

  data() {
    return {
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      currentPage: 1,
      perPage: 10,
      from: {
        idCese: "",
      },
      // Other data properties from GesCese.vue that are still needed in the parent
      // e.g., checkeId, pdfMasivo, pdfIndividual, texto, idRenovacion, motivo, masisvo, etc.
      // For brevity, I'm only including what's directly used by the new components or essential logic.
      dniUsuario: "",
      idTrabajador: "",
      // ... other data properties from GesCese.vue
    };
  },

  computed: {
    ...mapGetters("renovaciones", ["SeguimientoCese"]),

    filteredGestionCese() {
      let data = this.SeguimientoCese;

      if (this.Dni) {
        data = data.filter(item =>
          item.nroDocumento?.toString().includes(this.Dni)
        );
      }

      if (this.Apellidos) {
        const texto = this.Apellidos.toLowerCase();
        data = data.filter(item =>
          item.nomTrabajador?.toLowerCase().includes(texto)
        );
      }

      if (this.SubSubCentro) {
        const texto = this.SubSubCentro.toLowerCase();
        data = data.filter(item =>
          item.subSubCentroCostos?.toLowerCase().includes(texto)
        );
      }

      return data;
    },

    paginatedGestionCese() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredGestionCese.slice(start, start + this.perPage);
    },

    totalPages() {
      return Math.ceil(this.filteredGestionCese.length / this.perPage);
    }
  },

  watch: {
    Dni() {
      this.currentPage = 1;
    },
    Apellidos() {
      this.currentPage = 1;
    },
    SubSubCentro() {
      this.currentPage = 1;
    }
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");
    console.log("SeguimientoCese.vue - idPerfil:", localStorage.getItem("idPerfil"));
    // Fetch initial data
    this.SeguimientoCeses();
  },
   created() {
    this.cambiarEstadoNavbar();
  },


  methods: {
    ...mapActions("renovaciones", ["SeguimientoCeses"]),

    cambiarEstadoNavbar() {
      this.$store.dispatch('acciones/CambioNavbar', true);
    },

    // Methods that were in GesCese.vue and are still needed in the parent
    actualizarEstado(itema) {
      this.from.idCese = itema.idCese;

      // The original logic iterated over GestionCese to fetch SubSubCentro data.
      // This might need to be re-evaluated if that data is not directly related to the Cese item itself.
      // For now, I'll keep the original logic as is, assuming it's intended.
      for (let index of this.GestionCese) {
        if (index.idCese == itema.idCese) { // Changed from idRenovacion to idCese
          this.axios
            .get(
              `SubSubCentro/SScxTrabajador?idEmpresa=${index.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${index.renCodCC}&codSubCentro=${index.renCodScc}`
            )
            .then((r) => {
              // this.SubSubCentroCosto = r.data; // This data property is not defined in SeguimientoCese.vue
              console.log(r.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      // Original logic for isdisabled2 and axios.put for actionRen
      // This part needs to be adapted. `accionRen` is now `accionCese`.
      // `isdisabled2` is not defined in this component, and its usage needs to be clarified.
      // For now, I'll just include the axios call.
      this.axios.put("Renovacion/ModificarAccionxRen", this.from).then((r) => {
        console.log(r.data);
      });

      console.log(itema);
    },

    Registro(itema) {
      // Logic from GesCese.vue
      this.from.idCese = itema.idCese; // Ensure it's idCese for Cese module

      this.axios
        .put(
          `Renovacion/EstadoTerminadoCambio?idRenovacion=${this.from.idCese}` // Assuming this endpoint is for Cese now
        )
        .then((r) => {
          if (r.data == true) {
            Swal.fire(`Registro Realizado`, "", "success");
            this.SeguimientoCese();
            this.from.idCese = "";
          }
        });
    },

    navigateToDescuento(idTrabajador, idPerfil) {
      this.$router.push(`/DescuentoTecnologiaParams/${idTrabajador}/${idPerfil}`);
    },

  },
};
</script>

<style scoped>
.reducirTamaño {
  font-size: 0.65rem;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

</style>